// Sample parts catalog + helpers for the Layout Composer's Live Mobile SIMULATION.
// Lets the preview behave like the real site for the search → select → add-to-cart
// flow, against a SHARED mock cart (the `sim` object passed down from App.vue).
// Placeholder data only — not the real catalog.

export const SAMPLE_PARTS = [
  { sku: "NDS S 2011 PC", name: "Pug sealer liner", price: 489.5 },
  { sku: "NDH S 2011 PC", name: "Knife holder", price: 264.0 },
  { sku: "DSD S 0488 SR", name: "Spiral groove liner — R", price: 312.5 },
  { sku: "DSD S 0486 SR", name: "Spiral groove liner — L", price: 312.5 },
  { sku: "DBE S 0130 CI", name: "Die backing", price: 757.4 },
  { sku: "PSA S 3407 SP", name: "Pug sealer assembly", price: 196.04 },
  { sku: "EXT 90ADEX", name: "Extruder 90ADEX", price: 1840.0 },
  { sku: "NDS S 1180 PC", name: "Auger flight", price: 612.25 },
  { sku: "BLD S 2204 CI", name: "Mixer blade", price: 178.9 },
  { sku: "SHF S 0090 SS", name: "Drive shaft", price: 998.0 },
];

export function searchParts(q) {
  q = (q || "").trim().toLowerCase();
  if (!q) return [];
  var out = [];
  for (var i = 0; i < SAMPLE_PARTS.length && out.length < 6; i++) {
    var p = SAMPLE_PARTS[i];
    if ((p.sku + " " + p.name).toLowerCase().indexOf(q) >= 0) out.push(p);
  }
  return out;
}

export function addToCart(sim, part) {
  if (!sim || !part) return;
  if (!sim.cart) sim.cart = [];
  for (var i = 0; i < sim.cart.length; i++) {
    // Only merge quick-adds (no PO/ref) of the same sku into one line.
    if (sim.cart[i].sku === part.sku && sim.cart[i].dest === "Order" && !sim.cart[i].ref) {
      sim.cart[i].qty++;
      return;
    }
  }
  // Quick-adds (header search / Top 5) are Orders with no PO yet.
  sim.cart.push({
    sku: part.sku,
    name: part.name,
    price: part.price || 0,
    qty: 1,
    dest: "Order",
    ref: "",
    company: "",
    machine: "",
    assembly: "",
    sub: part.sub || "",
    _open: false,
  });
}

export function cartCount(sim) {
  if (!sim || !sim.cart) return 0;
  return sim.cart.reduce(function (n, it) {
    return n + it.qty;
  }, 0);
}

export function cartTotal(sim) {
  if (!sim || !sim.cart) return "0.00";
  var t = sim.cart.reduce(function (s, it) {
    return s + it.qty * (it.price || 0);
  }, 0);
  return t.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
